import { render } from "./ExternalProviders.vue?vue&type=template&id=f21c9fee&ts=true"
import script from "./ExternalProviders.vue?vue&type=script&lang=ts"
export * from "./ExternalProviders.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__